<script setup>
import MerchantIndex from "@/components/merchant/MerchantIndex.vue";
import MerchantExport from "@/components/merchant/MerchantExport.vue";
import MerchantImport from "@/components/merchant/MerchantImport.vue";

definePage({
  meta: {
    layout: "default",
  },
});
const pageTitle = "Data Merchant";

const breadCrumbs = [
  {
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    title: "Master Data",
    to: null,
  },
  {
    title: pageTitle,
    to: null,
  },
];

const route = useRoute();
const router = useRouter();

const navigationTab = ref(route.query.export ? 2 : 0);
const tabItems = ["Search", "Import", "Export"];
</script>

<template>
  <VBreadcrumbs :items="breadCrumbs" class="px-0 pt-0 pb-5" />
  <h4 class="text-h4 my-4">{{ pageTitle }}</h4>
  <VCard>
    <VTabs v-model="navigationTab">
      <VTab v-for="item in tabItems" :key="item">
        {{ item }}
      </VTab>
    </VTabs>
    <VWindow v-model="navigationTab">
      <VWindowItem :key="tabItems[0]">
        <MerchantIndex />
      </VWindowItem>
      <VWindowItem :key="tabItems[1]">
        <MerchantImport />
      </VWindowItem>
      <VWindowItem :key="tabItems[2]">
        <MerchantExport />
      </VWindowItem>
    </VWindow>
  </VCard>
  <!-- 👉 Delete Dialog  -->
  <VDialog v-model="deleteDialog" max-width="500px">
    <VCard v-show="!deleteAlert">
      <VCardTitle class="text-center my-3">
        <p>Are you sure you want to delete this item?</p>
        <h3>{{ deleteDialogDisplay }}</h3>
      </VCardTitle>

      <VCardActions>
        <VSpacer />
        <VBtn color="secondary" variant="outlined" @click="deleteCancel">
          Cancel
        </VBtn>
        <VBtn color="error" variant="elevated" @click="deleteOk(deleteDialog)">
          OK
        </VBtn>
        <VSpacer />
      </VCardActions>
    </VCard>
    <VCard v-show="deleteAlert">
      <VCardText>
        <VAlert type="error">
          {{ deleteAlert }}
        </VAlert>
      </VCardText>
    </VCard>
  </VDialog>
</template>
